export enum DataTableTabs {
    OPEN_ORDERS,
    EXPOSURE_TRADING_TOOLS,
    ORDER_HISTORY
}